import BaseService from './base.service';

export default class EmailDispatchConfigService extends BaseService {
    constructor() {
        super("EmailDispatchConfig");
    }

    list() {
        return this.getRequest('List');
    }

    listWithVariables() {
        return this.getRequest('ListWithVariables');
    }

    findWithVariables(id) {
        return this.getRequest(`FindWithVariables?id=${id}`);
    }

    toggleActive(id) {
        return this.putRequest(`ToggleActive?id=${id}`, null, true, true);
    }

    update(id, payload) {
        return this.putRequest(`Update?id=${id}`, payload, true, true);
    }

    create(payload) {
        return this.postRequest('Create', payload, true, true);
    }
}
